import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
interface LegalModalProps {
  open: ModalType;
  onClose: () => void;
}
const privacyContent = <div className="space-y-5 text-[#5C4A3A] text-sm leading-relaxed" data-id="element-371">
    <p data-id="element-372">Última actualización: 2025</p>

    <div data-id="element-373">
      <h3 className="font-bold text-[#2C1810] mb-2" data-id="element-374">
        1. Información que recopilamos
      </h3>
      <p data-id="element-375">
        Recopilamos únicamente la información necesaria para procesar tu pedido:
        nombre, dirección de correo electrónico y datos de pago. No recopilamos
        información sensible de salud ni compartimos tus datos con terceros sin
        tu consentimiento.
      </p>
    </div>

    <div data-id="element-376">
      <h3 className="font-bold text-[#2C1810] mb-2" data-id="element-377">
        2. Uso de la información
      </h3>
      <p data-id="element-378">
        Utilizamos tu información exclusivamente para: procesar y entregar tu
        pedido, enviarte actualizaciones relacionadas con tu compra, y mejorar
        nuestros productos y servicios. No vendemos ni alquilamos tu información
        personal a terceros.
      </p>
    </div>

    <div data-id="element-379">
      <h3 className="font-bold text-[#2C1810] mb-2" data-id="element-380">
        3. Seguridad de los datos
      </h3>
      <p data-id="element-381">
        Implementamos medidas de seguridad técnicas y organizativas para
        proteger tu información personal contra acceso no autorizado, pérdida o
        divulgación. Todos los pagos se procesan a través de plataformas seguras
        con cifrado SSL.
      </p>
    </div>

    <div data-id="element-382">
      <h3 className="font-bold text-[#2C1810] mb-2" data-id="element-383">4. Cookies</h3>
      <p data-id="element-384">
        Utilizamos cookies esenciales para el funcionamiento del sitio y cookies
        analíticas para entender cómo los visitantes interactúan con nuestra
        página. Puedes desactivar las cookies en la configuración de tu
        navegador.
      </p>
    </div>

    <div data-id="element-385">
      <h3 className="font-bold text-[#2C1810] mb-2" data-id="element-386">5. Tus derechos</h3>
      <p data-id="element-387">
        Tienes derecho a acceder, corregir o eliminar tu información personal en
        cualquier momento. Para ejercer estos derechos, puedes comunicarte con
        nosotros a través de los canales disponibles en nuestra plataforma de
        compra.
      </p>
    </div>

    <div data-id="element-388">
      <h3 className="font-bold text-[#2C1810] mb-2" data-id="element-389">
        6. Cambios en esta política
      </h3>
      <p data-id="element-390">
        Nos reservamos el derecho de actualizar esta política de privacidad en
        cualquier momento. Los cambios entrarán en vigor inmediatamente después
        de su publicación en este sitio.
      </p>
    </div>
  </div>;
const termsContent = <div className="space-y-5 text-[#5C4A3A] text-sm leading-relaxed" data-id="element-391">
    <p data-id="element-392">Última actualización: 2025</p>

    <div data-id="element-393">
      <h3 className="font-bold text-[#2C1810] mb-2" data-id="element-394">
        1. Aceptación de los términos
      </h3>
      <p data-id="element-395">
        Al realizar una compra en este sitio, aceptas estos Términos de Servicio
        en su totalidad. Si no estás de acuerdo con alguno de estos términos, te
        pedimos que no realices ninguna compra.
      </p>
    </div>

    <div data-id="element-396">
      <h3 className="font-bold text-[#2C1810] mb-2" data-id="element-397">
        2. Descripción del producto
      </h3>
      <p data-id="element-398">
        Nutrikia Herbal ofrece contenido digital educativo en formato de manual
        descargable. El contenido es de carácter informativo y no constituye
        asesoramiento médico. Los resultados individuales pueden variar.
      </p>
    </div>

    <div data-id="element-399">
      <h3 className="font-bold text-[#2C1810] mb-2" data-id="element-400">
        3. Política de reembolso
      </h3>
      <p data-id="element-401">
        Ofrecemos una garantía de satisfacción de 7 días. Si no estás satisfecho
        con tu compra por cualquier motivo, puedes solicitar un reembolso
        completo dentro de los 7 días posteriores a la compra, sin preguntas ni
        trámites adicionales.
      </p>
    </div>

    <div data-id="element-402">
      <h3 className="font-bold text-[#2C1810] mb-2" data-id="element-403">
        4. Propiedad intelectual
      </h3>
      <p data-id="element-404">
        Todo el contenido del manual, incluyendo textos, imágenes y protocolos,
        es propiedad exclusiva de Nutrikia Herbal y está protegido por las leyes
        de derechos de autor. Queda prohibida su reproducción, distribución o
        venta sin autorización expresa.
      </p>
    </div>

    <div data-id="element-405">
      <h3 className="font-bold text-[#2C1810] mb-2" data-id="element-406">
        5. Limitación de responsabilidad
      </h3>
      <p data-id="element-407">
        Este producto es de carácter educativo e informativo. Nutrikia Herbal no
        se hace responsable de los resultados individuales. Siempre consulta a
        un profesional de la salud antes de iniciar cualquier protocolo de salud
        natural, especialmente si tienes condiciones médicas preexistentes.
      </p>
    </div>

    <div data-id="element-408">
      <h3 className="font-bold text-[#2C1810] mb-2" data-id="element-409">6. Modificaciones</h3>
      <p data-id="element-410">
        Nutrikia Herbal se reserva el derecho de modificar estos términos en
        cualquier momento. El uso continuado del sitio después de dichas
        modificaciones constituye la aceptación de los nuevos términos.
      </p>
    </div>
  </div>;
export function LegalModal({
  open,
  onClose
}: LegalModalProps) {
  if (!open) return null;
  const isPrivacy = open === 'privacy';
  const title = isPrivacy ? 'Política de Privacidad' : 'Términos de Servicio';
  const content = isPrivacy ? privacyContent : termsContent;
  return <AnimatePresence data-id="element-411">
      {open && <>
          {/* Backdrop */}
          <motion.div key="backdrop" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 bg-black/60 backdrop-blur-sm z-[2000]" onClick={onClose} data-id="element-412" />

          {/* Modal */}
          <motion.div key="modal" initial={{
        opacity: 0,
        y: 40,
        scale: 0.97
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.97
      }} transition={{
        duration: 0.3,
        ease: 'easeOut'
      }} className="fixed inset-0 z-[2001] flex items-center justify-center px-4 py-8 pointer-events-none" data-id="element-413">
            <div className="bg-[#FEFCF6] rounded-2xl shadow-2xl border border-[#E8DFD0] w-full max-w-lg max-h-[80vh] flex flex-col pointer-events-auto" data-id="element-414">
              {/* Header */}
              <div className="flex items-center justify-between px-6 py-4 border-b border-[#E8DFD0] shrink-0" data-id="element-415">
                <div className="flex items-center gap-3" data-id="element-416">
                  <div className="w-2 h-6 bg-[#2D5A3D] rounded-full" data-id="element-417"></div>
                  <h2 className="font-serif font-bold text-[#2C1810] text-lg" data-id="element-418">
                    {title}
                  </h2>
                </div>
                <button onClick={onClose} className="w-8 h-8 flex items-center justify-center rounded-full bg-[#F0F4EC] hover:bg-[#E8DFD0] text-[#5C4A3A] transition-colors" data-id="element-419">
                  <X className="w-4 h-4" data-id="element-420" />
                </button>
              </div>

              {/* Scrollable Content */}
              <div className="overflow-y-auto px-6 py-5 flex-1" data-id="element-421">{content}</div>

              {/* Footer */}
              <div className="px-6 py-4 border-t border-[#E8DFD0] shrink-0 text-center" data-id="element-422">
                <button onClick={onClose} className="bg-[#2D5A3D] text-white font-bold text-sm px-8 py-2.5 rounded-lg hover:bg-[#1B4332] transition-colors" data-id="element-423">
                  Entendido
                </button>
              </div>
            </div>
          </motion.div>
        </>}
    </AnimatePresence>;
}